import React from 'react';
import { AdminPageHeader } from '../../components/admin/shell';
import ProPagesPanel from '../../components/admin/ProPagesPanel';

export default function ProPagesPage() {
  return (
    <>
      <AdminPageHeader section="pro-pages" meta="Every Pro page, claimed or listed. Unpublish takes it off the directory." />
      <ProPagesPanel />
    </>
  );
}
